// import {initializeApp, auth} from "firebase/compat/app"
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import 'firebase/storage';

// Live
const firebaseConfig = {
    apiKey: "AIzaSyDm2YXEYFG5KrdPoPisIX92ruZva8iTNsI",
    authDomain: "medicare-1022d.firebaseapp.com",
    projectId: "medicare-1022d",
    storageBucket: "medicare-1022d.firebasestorage.app",
    messagingSenderId: "849814811137",
    appId: "1:849814811137:web:3d534bdab1b23e43ef8600",
    measurementId: "G-44WZTRS82C"
};

// Dev
// const firebaseConfig = {
//     apiKey: "AIzaSyDAjWzoT8EyQvHUeReFBgyeK0AILrhT5xw",
//     authDomain: "medicare-dev-4fd86.firebaseapp.com",
//     projectId: "medicare-dev-4fd86",
//     storageBucket: "medicare-dev-4fd86.firebasestorage.app",
//     messagingSenderId: "729600420353",
//     appId: "1:729600420353:web:d38441a8c2adbf20a4ae00",
//     measurementId: "G-Y975XG2DDZ"
//   };

const app = initializeApp(firebaseConfig);
export const firebaseApp = app;
export const auth = getAuth(app);